import { gql, makeVar } from '@apollo/client';
import { useQuery } from '@tbitop/api';
import { useTelemetry } from '@tbitop/telemetry';
import { defaultTo, isNull } from 'lodash-es';
import { useEffect } from 'react';
import { log } from '../../log';
import type { VersionQuery } from './__generated__/versions';

export const clientVersionVar = makeVar('');

export const useVersions = () => {
  const { loading, error, data } = useQuery<VersionQuery>(
    gql`
      query Version {
        versionen {
          apiVersion
          clientVersion @client
        }
      }
    `,
    {
      onError: error => log.error('Failed to load versions.', error),
    },
  );
  const telemetry = useTelemetry();

  useEffect(() => {
    (async () => {
      const response = await fetch(`${defaultTo(process.env.NEXT_PUBLIC_BASE_PATH, '')}/version.json`);
      const { version } = await response.json();
      clientVersionVar(version);
    })();
  }, []);

  const apiVersion = defaultTo(data?.versionen.apiVersion, null);
  const clientVersion = defaultTo(data?.versionen.clientVersion, null);

  useEffect(
    () => {
      if (!isNull(clientVersion)) {
        telemetry?.setClientVersion(clientVersion);
      }
    },
    [clientVersion, telemetry],
  );

  return {
    loading,
    error,
    apiVersion: defaultTo(apiVersion, 'NO_VERSION'),
    clientVersion: defaultTo(clientVersion, 'NO_VERSION'),
  };
};
